const stockImageExamples: {
    [index: string]: { designer: string; designPath: string; stockPaths: string[] };
} = {
    'postcard-flyer-design': {
        designer: 'YaseenArt',
        designPath: require('images/stock-usage-examples/3.png'),
        stockPaths: [require('images/stock-usage-examples/3.1.png')],
    },
    'menu-design': {
        designer: 'YaseenArt',
        designPath: require('images/stock-usage-examples/3.png'),
        stockPaths: [require('images/stock-usage-examples/3.1.png')],
    },
    'other-business-advertising': {
        designer: 'YaseenArt',
        designPath: require('images/stock-usage-examples/3.png'),
        stockPaths: [require('images/stock-usage-examples/3.1.png')],
    },
    'other-design': {
        designer: 'YaseenArt',
        designPath: require('images/stock-usage-examples/3.png'),
        stockPaths: [require('images/stock-usage-examples/3.1.png')],
    },
    'signage-design': {
        designer: 'YaseenArt',
        designPath: require('images/stock-usage-examples/3.png'),
        stockPaths: [require('images/stock-usage-examples/3.1.png')],
    },
    'poster-design': {
        designer: 'ultrastjarna',
        designPath: require('images/stock-usage-examples/4.png'),
        stockPaths: [
            require('images/stock-usage-examples/4.1.png'),
            require('images/stock-usage-examples/4.2.png'),
            require('images/stock-usage-examples/4.3.png'),
        ],
    },
    'podcast-cover-design': {
        designer: 'ultrastjarna',
        designPath: require('images/stock-usage-examples/4.png'),
        stockPaths: [
            require('images/stock-usage-examples/4.1.png'),
            require('images/stock-usage-examples/4.2.png'),
            require('images/stock-usage-examples/4.3.png'),
        ],
    },
    'album-cover-design': {
        designer: 'ultrastjarna',
        designPath: require('images/stock-usage-examples/4.png'),
        stockPaths: [
            require('images/stock-usage-examples/4.1.png'),
            require('images/stock-usage-examples/4.2.png'),
            require('images/stock-usage-examples/4.3.png'),
        ],
    },
    'car-truck-van-wrap-design': {
        designer: 'Jdodo',
        designPath: require('images/stock-usage-examples/5.png'),
        stockPaths: [require('images/stock-usage-examples/5.1.png')],
    },
    'cup-mug-design': {
        designer: '☰ ALEX LALOVE ☷',
        designPath: 'images/stock-usage-examples/6.png',
        stockPaths: [require('images/stock-usage-examples/6.1.png')],
    },
    'merchandise-design': {
        designer: '☰ ALEX LALOVE ☷',
        designPath: 'images/stock-usage-examples/6.png',
        stockPaths: [require('images/stock-usage-examples/6.1.png')],
    },
    'other-clothing-merchandise-design': {
        designer: '☰ ALEX LALOVE ☷',
        designPath: 'images/stock-usage-examples/6.png',
        stockPaths: [require('images/stock-usage-examples/6.1.png')],
    },
    'sticker-design': {
        designer: '☰ ALEX LALOVE ☷',
        designPath: 'images/stock-usage-examples/6.png',
        stockPaths: [require('images/stock-usage-examples/6.1.png')],
    },
    'other-packaging-label-design': {
        designer: 'tomdesign.org',
        designPath: require('images/stock-usage-examples/7.png'),
        stockPaths: [
            require('images/stock-usage-examples/7.1.png'),
            require('images/stock-usage-examples/7.2.png'),
            require('images/stock-usage-examples/7.3.png'),
        ],
    },
    'product-packaging-design': {
        designer: 'tomdesign.org',
        designPath: require('images/stock-usage-examples/7.png'),
        stockPaths: [
            require('images/stock-usage-examples/7.1.png'),
            require('images/stock-usage-examples/7.2.png'),
            require('images/stock-usage-examples/7.3.png'),
        ],
    },
    'product-label-design': {
        designer: 'tomdesign.org',
        designPath: require('images/stock-usage-examples/7.png'),
        stockPaths: [
            require('images/stock-usage-examples/7.1.png'),
            require('images/stock-usage-examples/7.2.png'),
            require('images/stock-usage-examples/7.3.png'),
        ],
    },
    'magazine-cover-design': {
        designer: 'Proi',
        designPath: require('images/stock-usage-examples/8.png'),
        stockPaths: [
            require('images/stock-usage-examples/8.1.png'),
            require('images/stock-usage-examples/8.2.png'),
            require('images/stock-usage-examples/8.3.png'),
        ],
    },
    'other-book-magazine-design': {
        designer: 'Proi',
        designPath: require('images/stock-usage-examples/8.png'),
        stockPaths: [
            require('images/stock-usage-examples/8.1.png'),
            require('images/stock-usage-examples/8.2.png'),
            require('images/stock-usage-examples/8.3.png'),
        ],
    },
};

export default stockImageExamples;
